import * as React from "react"
import { cn } from "../utils"

type SectionProps = {
  title: string | React.ReactNode
  description?: string | React.ReactNode
  action?: React.ReactNode
  children?: React.ReactNode
  className?: string
  titleClassName?: string
  descriptionClassName?: string
}

export const Section = React.forwardRef<HTMLDivElement, SectionProps>(
  (
    {
      title,
      description,
      action,
      className,
      titleClassName,
      descriptionClassName,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div ref={ref} className={cn("flex-1 w-full flex flex-col gap-6", className)} {...props}>
        <div className="flex flex-col md:flex-row items-start justify-between md:gap-6 gap-2">
          <div className="flex flex-col gap-1">
            <h1 className={cn("text-xl font-semibold", titleClassName)}>{title}</h1>
            {description && (
              <div
                className={cn("text-base text-muted-foreground max-w-3xl", descriptionClassName)}
              >
                {description}
              </div>
            )}
          </div>
          {action && <div>{action}</div>}
        </div>
        {children}
      </div>
    )
  },
)

Section.displayName = "Section"
